import {
    createSlice,
} from '@reduxjs/toolkit'

const initialState = {
    modules: null,
    current: { id: 0, name: "Unknown", themename: "" },
}

const companySlice = createSlice({
    name: 'companies',
    initialState,
    reducers: {
        setCompany(state, action) {
            state.current.id = action.payload.id
            state.current.name = action.payload.name
            if (!!action.payload.themename) {
                state.current.themename = action.payload.themename
            }
            state.modules = action.payload.modules
        },
        setTheme(state, action) {
            if (!!action.payload) {
                state.current.themename = action.payload
            }
        }
    },
})

export const { setCompany, setTheme } = companySlice.actions
export const currentCompany = (state) => state.company.current
export const companyModules = (state) => state.company.modules

export default companySlice.reducer
